import React from 'react';
export function HeroSection() {
  return <section id="hero-section" className="relative w-full flex flex-col text-center px-4 pt-8 pb-10 sm:pt-12 sm:pb-16 items-center justify-center overflow-hidden bg-bg-main" data-id="element-137">
      {/* Brand */}
      <span className="relative inline-block font-serif font-black text-lg sm:text-2xl tracking-tight text-primary mb-3 sm:mb-4" data-id="element-138">
        SPORTUNTERRICHT<span className="text-text-main" data-id="element-139"> FERTIG</span>
      </span>

      {/* Main headline */}
      <h1 className="relative font-serif font-black max-w-4xl text-[30px] leading-[1.12] sm:text-5xl md:text-6xl sm:leading-[1.1] mb-3 sm:mb-5 tracking-tight text-text-main" data-id="element-140">
        Löse ein komplettes Schuljahr Sportunterricht in nur{' '}
        <span className="text-primary italic font-serif" data-id="element-141">
          5 Minuten Vorbereitung
        </span>
      </h1>

      {/* Subheadline */}
      <p className="relative text-sm sm:text-lg font-medium leading-relaxed mb-5 sm:mb-7 max-w-2xl mx-auto text-text-sec" data-id="element-142">
        Das komplette digitale PDF-Paket für Sportlehrer in Deutschland: 12
        Bände, Jahresplanungen, fertige Sportstunden, Übungen, Bewertungen,
        Arbeitsblätter und Bonus-Materialien — alles sofort einsetzbar.
      </p>

      {/* Mockup image */}
      <div className="relative w-full max-w-[380px] sm:max-w-[620px] md:max-w-[740px] mx-auto mb-6 sm:mb-8" data-id="element-143">
        <img src="https://cdn.magicpatterns.com/uploads/k2PuDt2WEq8iqbty1cCSQF/Diseno-sin-titulo-_98_.webp" alt="SPORTUNTERRICHT FERTIG — Digitales PDF-Paket mit 12 Bänden für Sportlehrer" className="relative w-full h-auto object-contain sm:drop-shadow-[0_20px_40px_rgba(22,195,74,0.14)]" width={1080} height={680} fetchPriority="high" loading="eager" decoding="async" data-id="element-144" />
      </div>

      {/* CTA Button */}
      <a href="#pricing" className="relative btn-primary-pulse font-bold text-base sm:text-xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl transition-colors inline-flex items-center justify-center gap-2 mb-3 sm:mb-4 w-full sm:w-auto max-w-xl text-white bg-primary hover:bg-primary-hover shadow-[0_10px_30px_-10px_rgba(22,195,74,0.5)]" data-id="element-145">
        <span aria-hidden="true" data-id="element-146">🚀</span>
        ICH WILL DAS KOMPLETTE PAKET
      </a>

      {/* Trust badges */}
      <p className="text-text-sec text-xs sm:text-sm font-medium flex items-center justify-center gap-x-4 gap-y-2 flex-wrap" data-id="element-147">
        <span className="flex items-center gap-1" data-id="element-148">
          <span aria-hidden="true" data-id="element-149">🔒</span> Sicherer Kauf
        </span>
        <span className="flex items-center gap-1" data-id="element-150">
          <span aria-hidden="true" data-id="element-151">⚡</span> Sofortiger digitaler Zugang
        </span>
        <span className="flex items-center gap-1" data-id="element-152">
          <span aria-hidden="true" data-id="element-153">🛡️</span> 7 Tage Geld-zurück-Garantie
        </span>
        <span className="flex items-center gap-1" data-id="element-154">
          <span aria-hidden="true" data-id="element-155">📘</span> 100% PDF — sofort downloadbar
        </span>
      </p>
    </section>;
}